import { CommonModule } from '@angular/common';
import { ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, ɵsetClassMetadata, NgModule } from '@angular/core';
import * as moment from 'moment';

class BaseModelsModule {
}
BaseModelsModule.ɵmod = ɵɵdefineNgModule({ type: BaseModelsModule });
BaseModelsModule.ɵinj = ɵɵdefineInjector({ factory: function BaseModelsModule_Factory(t) { return new (t || BaseModelsModule)(); }, imports: [[CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(BaseModelsModule, { imports: [CommonModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseModelsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule
                ],
                declarations: [],
                exports: []
            }]
    }], null, null); })();

class Alert {
    constructor(init) {
        this.cssClass = '';
        //timeout:number;
        this.timeout = 1000;
        Object.assign(this, init);
    }
}
var AlertType;
(function (AlertType) {
    AlertType[AlertType["Success"] = 0] = "Success";
    AlertType[AlertType["Error"] = 1] = "Error";
    AlertType[AlertType["Info"] = 2] = "Info";
    AlertType[AlertType["Warning"] = 3] = "Warning";
    AlertType[AlertType["error_conection"] = 4] = "error_conection";
})(AlertType || (AlertType = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["Success"] = "success";
    NotificationType["Error"] = "error";
    NotificationType["Info"] = "info";
    NotificationType["Warning"] = "warning";
})(NotificationType || (NotificationType = {}));

class AppInjector {
    static setInjector(injector) {
        AppInjector._injector = injector;
    }
    static getInjector() {
        return AppInjector._injector;
    }
}

class CompanyBase {
}

/**
 * generic class to use with dates
 */
class DateRange {
    constructor() {
    }
    set dt_start(value) {
        if (value != null) {
            this._dt_start = DateRange.getdate00zone(value);
        }
        else {
            this._dt_start = value;
        }
    }
    get dt_start() { return this._dt_start; }
    set dt_end(value) {
        if (value != null) {
            this._dt_end = DateRange.getdate00zone(value);
        }
        else {
            this._dt_end = value;
        }
    }
    get dt_end() { return this._dt_end; }
    isEqual(dt2check) {
        let m1 = moment(DateRange.getdate00zone(this._dt_start));
        let m2 = moment(DateRange.getdate00zone(this._dt_end));
        if (m1.isSame(dt2check.getdtstart00()) && m2.isSame(dt2check.getdtend00())) {
            return true;
        }
        else {
            return false;
        }
    }
    isSameOrAfter(dt2check) {
        let m1 = this.getdtstartasmoment();
        let dt100 = DateRange.getdate00zone(dt2check);
        if (m1.isSameOrAfter(dt100)) {
            return true;
        }
        else {
            return false;
        }
    }
    isSameOrBefore(dt2check) {
        let m1 = this.getdtendasmoment();
        let dt100 = DateRange.getdate00zone(dt2check);
        if (m1.isSameOrBefore(dt100)) {
            return true;
        }
        else {
            return false;
        }
    }
    isEqualByDates(dt1, dt2) {
        let m1 = this.getdtstartasmoment();
        let m2 = this.getdtendasmoment();
        let dt100 = DateRange.getdate00zone(dt1);
        let dt200 = DateRange.getdate00zone(dt2);
        if (m1.isSame(dt100) && m2.isSame(dt200)) {
            return true;
        }
        else {
            return false;
        }
    }
    getdtstartasmoment() {
        let m1 = moment(this.getdtstart00());
        return m1;
    }
    getdtendasmoment() {
        let m1 = moment(this.getdtend00());
        return m1;
    }
    getdtstart00() {
        return DateRange.getdate00zone(this._dt_start);
    }
    getdtstart00String() {
        return DateRange.getdate00zoneAsString(this._dt_start);
    }
    getdtend00() {
        return DateRange.getdate00zone(this._dt_end);
    }
    getdtend00String() {
        return DateRange.getdate00zoneAsString(this._dt_end);
    }
    /**
     * Add days to to Start date of this DateRange
     * @param daysToAdd
     */
    addDaysToStart(daysToAdd) {
        this._dt_start = DateRange.addDaysTo(this._dt_start, daysToAdd);
    }
    /**
     * Add days to to End date of this DateRange
     * @param daysToAdd
     */
    addDaysToEnd(daysToAdd) {
        this._dt_end = DateRange.addDaysTo(this.dt_end, daysToAdd);
    }
    /**
     * Return a Date as string with zone 00
     * @param dt
     */
    static getdate00zoneAsString(dt) {
        let dtm = moment(dt);
        //let str=dtn.year() + "-" + (dtn.month()+1) +"-" + dtn.date() + "T00:00:00Z";
        //let str1=dtn.toISOString();
        let str2 = dtm.format("YYYY-MM-DD");
        str2 += "T00:00:00Z";
        return str2;
    }
    static getdateOnlyAsString(dt) {
        let dtm = moment(dt);
        let str2 = dtm.format("YYYY-MM-DD");
        return str2;
    }
    static getdateAsString(dt, format) {
        let dtm = moment(dt);
        let str2 = dtm.format(format);
        return str2;
    }
    /**
     * Return days diff
     * @param dateFrom
     * @param dateTo
     */
    static getDaysDiffByMoment(dateFrom, dateTo) {
        let a = dateFrom;
        let b = dateTo;
        let res = b.diff(a.startOf('day'), 'days');
        return res;
    }
    /**
     * Return days diff between 2 days in Date format that are converted to moments
     * @param dateFrom
     * @param dateTo
     */
    static getDaysDiff(dateFrom, dateTo) {
        let a = moment(dateFrom);
        let b = moment(dateTo);
        let res = b.diff(a.startOf('day'), 'days');
        return res;
    }
    /**
     * Return date passed as new date with 00Zone
     * @param dt
     */
    static getdate00zone(dt) {
        let dtm = moment(dt);
        //let str=dtn.year() + "-" + (dtn.month()+1) +"-" + dtn.date() + "T00:00:00Z";
        //let str1=dtn.toISOString();
        let str2 = dtm.format("YYYY-MM-DD");
        str2 += "T00:00:00Z";
        return new Date(str2);
    }
    /**
     * Return date passed as Moment with 00Zone
     * @param dt
     */
    static getdate00zoneAsmoment(dt) {
        let dtm = moment(dt);
        //let str=dtn.year() + "-" + (dtn.month()+1) +"-" + dtn.date() + "T00:00:00Z";
        //let str1=dtn.toISOString();
        let str2 = dtm.format("YYYY-MM-DD");
        str2 += "T00:00:00Z";
        let m1 = moment(new Date(str2));
        return m1;
    }
    /**
     * Return moment passed as Date with 00Zone
     * @param dtm
     */
    static getdate00bymoment(dtm) {
        let str2 = dtm.format("YYYY-MM-DD");
        str2 += "T00:00:00Z";
        return new Date(str2);
    }
    /**
     * Return moment passed as Date with 00Zone
     * @param dtm
     */
    static getmoment00bymoment(dtm) {
        let str2 = dtm.format("YYYY-MM-DD");
        str2 += "T00:00:00Z";
        return moment(str2);
    }
    /**
     * Check if 2 ranges are equal input values are Date.
     * Dates are converted to 00zone
     * @param dt_start
     * @param dt_end
     * @param dt1
     * @param dt2
     */
    static isEqualByRange(dt_start, dt_end, dt1, dt2) {
        let m1 = moment(this.getdate00zone(dt_start));
        let m2 = moment(this.getdate00zone(dt_end));
        let dt100 = this.getdate00zone(dt1);
        let dt200 = this.getdate00zone(dt2);
        /*  console.log("m1",m1);
         console.log("m2",m2);
         console.log("dt1",dt1);
         console.log("dt2",dt2); */
        if (m1.isSame(dt100) && m2.isSame(dt200)) {
            return true;
        }
        else {
            return false;
        }
    }
    static isBetweenByRange(dateToFind, dt_start, dt_end) {
        const dt_start00 = DateRange.getmoment00bymoment(dt_start);
        const dt_end00 = DateRange.getmoment00bymoment(dt_end);
        if (dateToFind.isBetween(dt_start, dt_end, null, "[]")) {
            return true;
        }
        else {
            return false;
        }
    }
    static addDaysTo(dateTo, daysToAdd) {
        let dt2 = DateRange.getdate00zoneAsmoment(dateTo);
        if (daysToAdd > 0) {
            dt2.add(Math.abs(daysToAdd), 'days');
        }
        else {
            dt2.subtract(Math.abs(daysToAdd), 'days');
        }
        return DateRange.getdate00bymoment(dt2);
    }
}

class ErrorBase {
    constructor(type, msg = "") {
        this.type = "";
        this.msg = "";
        this.msg = msg;
        this.type = type;
    }
}
class ErrorServer {
    constructor() {
        this.code = "";
        this.message = "";
        this.operation = "";
    }
    static getErrorFormated(error) {
        if (!error) {
            return "";
        }
        let msg = "";
        let code = error.code;
        let message = error.message;
        let operation = error.operation;
        if (code) {
            msg = " Error Code:" + error.code;
        }
        if (message) {
            msg += " Message:" + message;
        }
        if (operation) {
            msg += " Operation:" + operation;
        }
        return msg;
    }
}

class FilterDTO {
    constructor() {
        this.filteritems = new Array();
    }
}
class FilterParam {
    constructor(key, value, type) {
        this.key = key;
        this.value = value;
        this.type = type;
    }
}

class InfoExt {
}

class InfoUser extends InfoExt {
    constructor() {
        super(...arguments);
        this.sites = [];
    }
}

/**
 * Class used to show error messages in messagebar for example
 */
class MessageError {
    constructor(type, text, cssClass) {
        this.type = type;
        this.text = text;
        this.cssClass = cssClass;
    }
}

//class to use in matlist option
class OptionList {
    constructor(value, selected) {
        this.value = value;
        this.selected = selected;
    }
}

class Person {
}

class ReqFilterHelper {
    /**
     * Return an string for get filters like {"columns":["id","name"]}
     * @param cols columns names array for filter
     */
    static columnsFilter(cols) {
        let columns = "";
        let sep = "";
        for (let col of cols) {
            columns += sep + '"' + col + '"';
            sep = ",";
        }
        let str = 'filter={"columns":[' + columns + ']}';
        return str;
    }
}
/**
 * Enumerations with tipical table column names
 */
var tableCol;
(function (tableCol) {
    tableCol["id"] = "id";
    tableCol["name"] = "name";
})(tableCol || (tableCol = {}));

class UserProfileBase {
    constructor() {
        this.access_level = [];
    }
}

class InfoUser$1 extends InfoExt {
    constructor() {
        super(...arguments);
        this.sites = [];
    }
}

class UserBase extends Person {
    constructor() {
        super(...arguments);
        this.info = new InfoUser$1();
        this.profile = new UserProfileBase();
        this.company = new CompanyBase();
        this.entities_acl = [];
    }
    fullname() {
        return this.name + " " + this.surname;
    }
    /*     public static configObject(source: any,appcontrols: ResourceRole[]): UserBase {
            let objUser = new UserBase();
            Object.assign(objUser, source.user);
            objUser.token = source.token;
            if (!objUser.profile) {
                objUser.profile = new UserProfileBase();
            }
            else if (!objUser.profile.hasOwnProperty("access_level")) {
                objUser.profile = new UserProfileBase();
            }
            objUser.profile.access_level.push(source.user.info.access_level);
            if (!objUser.resourceList) {
                UserBase.configControlAccess(objUser,appcontrols);//todo:eliminar cuando la lista venga llena del servidor
            }
    
            UserBase.configEntitiesAccessList(objUser);
    
            //console.log("auth response", source.user);
            //console.log("auth response token object", source.token);
            //console.log(obj.fullname());
            return objUser;
        } */
    /*     private static configEntitiesAccessList(user: UserBase){
            
            let obj:any=user;
            if (obj.info && obj.info.sites){
                for (let site of obj.info.sites){
                    let acl=site.company_acl;
                    if (acl && acl.access_level){
                       user.entities_acl.push({id:site.id,acl:acl.access_level});
                    }
                                  
                }
            }
            console.log("User access list acl",user.entities_acl);
        } */
    static configControlAccess(user, appcontrols) {
        user.resourceList = [];
        let userRoles = new Set(user.profile.access_level);
        for (let res of appcontrols) {
            for (let rol of res.roles) {
                const resp = userRoles.has(rol);
                if (resp) {
                    user.resourceList.push(res);
                    continue;
                }
            }
        }
        //console.log(user.resourceList);
    }
}

class UserRole {
}

/*
 * Public API Surface of base-models
 */

var EditionEnum;
(function (EditionEnum) {
    EditionEnum[EditionEnum["NEW"] = -1] = "NEW";
    EditionEnum[EditionEnum["READ"] = 0] = "READ";
    EditionEnum[EditionEnum["EDIT"] = 1] = "EDIT";
})(EditionEnum || (EditionEnum = {}));

/*
 * Public API Surface of base-models
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Alert, AlertType, AppInjector, BaseModelsModule, CompanyBase, DateRange, EditionEnum, ErrorBase, ErrorServer, FilterDTO, FilterParam, InfoExt, InfoUser, MessageError, NotificationType, OptionList, Person, ReqFilterHelper, UserBase, UserProfileBase, UserRole, tableCol };
//# sourceMappingURL=base-models.js.map
